import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CommonChartmoduleService } from '../../../Services/common-chartmodule.service';
import { SnapshotService } from '../../../Services/snapshot.service';

@Injectable({
  providedIn: 'root',
})
export class ScatterchartService {
  constructor(private http: HttpClient,private commonchartmodules:CommonChartmoduleService, private _configService: SnapshotService ) { }

  // color: string[] = [
  //   '#9BC5E5',
  //   '#D5BCE4',
  //   '#F9C099',
  //   '#FF97A8',
  //   '#A6E2D7',
  //   '#BDE6BD',
  //   '#BFE1FD',
  //   '#F4E4B3',
  //   '#CD978B',
  //   '#EAC4D5',
  // ];

  color: string[]=this.commonchartmodules.color1;
  baseImgPath: string = 'assets/Images/Scatter/';
  fontFamily='KantarBrown-Regular';
  

  applycustomization(event:any,item:any,properties:any){
    this.commonchartmodules.applycustomization(event,item,properties)
  }

  list:any;
  ScatterChartCustomizationList():Observable<any[]>{
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Scatter Chart")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist().slice(0,this.commonchartmodules.commoncustomizationlist().length-1)]
        return custom;
      })
    );
  
  }
  QuadrantScatterChartCustomizationList():Observable<any[]>{
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Quadrant Scatter Chart")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XaxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist().slice(0,this.commonchartmodules.commoncustomizationlist().length-1)]
        custom.push( {
          customization: 'Quadrant Dash Style :',
          func: 'applycustomization',
          inputType: 'dropdown',
          className: "",
          id: 'Quadrant Dash Style :',
          options: [
            { value: 'dash', label: 'Dash' },
            { value: 'shortdash', label: 'ShortDash' },
            { value: 'dot', label: 'Dot' },
            { value: 'solid', label: 'Solid' },
            { value: 'shortDashDot', label: 'ShortDashDot' },
            { value: 'shortDashDotDot', label: 'ShortDashDotDot' },
            { value: 'longDash', label: 'LongDash' },
            { value: 'longDashDot', label: 'LongDashDot' },
          ],
        },)
        return custom;
      })
    );
  
  }
  BubblerChartCustomizationList():Observable<any[]>{
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Bubble Chart")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist().slice(0,this.commonchartmodules.commoncustomizationlist().length-1)]
        return custom;
      })
    );
  
  }
  QuadrantBubbleChartCustomizationList():Observable<any[]>{
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Quadrant Bubble Chart")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist().slice(0,this.commonchartmodules.commoncustomizationlist().length-1)]
        custom.push( {
          customization: 'Quadrant Dash Style :',
          func: 'applycustomization',
          inputType: 'dropdown',
          className: "",
          id: 'Quadrant Dash Style :',
          options: [
            { value: 'dash', label: 'Dash' },
            { value: 'shortdash', label: 'ShortDash' },
            { value: 'dot', label: 'Dot' },
            { value: 'solid', label: 'Solid' },
            { value: 'shortDashDot', label: 'ShortDashDot' },
            { value: 'shortDashDotDot', label: 'ShortDashDotDot' },
            { value: 'longDash', label: 'LongDash' },
            { value: 'longDashDot', label: 'LongDashDot' },
          ],
        },)
        return custom;
      })
    );
  
  }
  


   customization() {
    let custom: any = [
      {
        customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',options: this._configService.clientSnapshotAllStudyNames
      },
      {
        customization:'Metric : ', func: 'applycustomization', inputType: 'checkboxlist', className: '', id: '',select:1,options: [
          { value: 'metric1', label: 'Metric 1' },{ value: 'metric2', label: 'Metric 2' },{ value: 'metric3', label: 'Metric 3' },{ value: 'metric4', label: 'Metric 4' },
        ]
      },
      {
        customization: 'Widget Name : ', func: 'applycustomization', inputType: 'text', className: '', id: ''
      },
      {
        customization:'X Axis Label Orientation : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: 'X Axis Label Orientation',options: [
          { value: 'automatic', label: 'Automatic' },
          { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
          { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
          { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisAngled', selectedImgClassName: 'axisAngledSelected' },
        ]
      },
      {
        customization:'Y Axis Label Orientation : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: 'Y Axis Label Orientation',options: [
          { value: 'automatic', label: 'Automatic' },
          { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
          { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
          { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisAngled', selectedImgClassName: 'axisAngledSelected' },
        ]
      },
    ];
    custom=[...custom,...this.commonchartmodules.commoncustomizationlist().slice(0,this.commonchartmodules.commoncustomizationlist().length-1)];
  
    return custom;
  }

  commonfunction(event: any, checkboxchecked: any, chartproperties: any) {
    switch (checkboxchecked) {
      case 'Dark Theme': {
        event.target.classList.toggle('checked')
          ? (chartproperties['darkTheme'] = true)
          : (chartproperties['darkTheme'] = false);
        break;
      }

      case 'Legend : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['showLegend'] = value == 'disable' ? false : true;
        break;
      }
      case 'Legend Position : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['legendPosition'] = value;
        break;
      }
      case 'Data Label : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['showDataLabel'] = value == 'disable' ? false : true;
        break;
      }
      case 'Data Label Color : ': {
        chartproperties['dataLabelColor'] = event.target.value;
        break;
      }
      case 'Data Label Format : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['datalabelFormat'] = value;
        break;
      }
      case 'Data Label Property : ': {
        chartproperties['datalabelStyle'] = event.target.value;
        break;
      }
      case 'Chart Title Position : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['chartTitlePosition'] = value;
        break;
      }
      case 'Marker Style : ': {
        chartproperties['markerStyle'] = event.target.value;
        break;
      }
      case 'Gridlines': {
        event.target.classList.toggle('checked')
          ? (chartproperties['gridlines'] = true)
          : (chartproperties['gridlines'] = false);
        break;
      }
      case '2D/3D Chart# : ': {
        chartproperties['is3D'] = event.target.value === '3D';
        break;
      }
      case 'Quadrant Dash Style : ': {
        chartproperties['dashStyle'] = event.target.value;
        break;
      }
      case 'Quadrant Text : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['showQuadrantText'] =
          value === 'enable' ? 'enable' : 'disable';
        break;
      }
      case 'Quadrant Color# : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['showQuadrantcolor'] =
          value === 'enable' ? 'enable' : 'disable';
        break;
      }
      case 'Gradient# : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['showGradient'] =
          value === 'enable' ? 'enable' : 'disable';
        break;
      }
      case 'Data Label Size# : ': {
        chartproperties['dataLabelSize'] = event.target.value;
        break;
      }
      case 'ToolTip Style# : ': {
        chartproperties['toolTipStyle'] = event.target.value;
        break;
      }
      case 'Data Label Style : ': {
        chartproperties['datalabelStyle'] = event.target.value;
        break;
      }
    }

    return chartproperties;
  }

  bubblecolors: any = [
    '#9BC5E5',
    '#D5BCE4',
    '#F9C099',
    '#FF97A8',
    '#A6E2D7',
    '#BDE6BD',
    '#BFE1FD',
    '#F4E4B3',
    '#CD978B',
    '#EAC4D5',
  ];
  bubbleupdatedCategories: any[] = [
    {
      name: 'Brand 1',
      image:
        'data:image/png;base64,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',
    },
    {
      name: 'Brand 2',
      image:
        'data:image/png;base64,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',
    },
    {
      name: 'Brand 3',
      image:
        'data:image/png;base64,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',
    },
    {
      name: 'Brand 4',
      image:
        'data:image/jpeg;base64,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',
    },
    {
      name: 'Brand 5',
      image:
        'data:image/png;base64,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',
    },
    {
      name: 'Brand 6',
      image:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAABaFBMVEX///8AAAAftToCot4BAQH60Rf7+/sfsjoDn9r+/v78/Pz1zRj3zhf70hf/1hj/2BgAoOQAtDsAoeD/0wD/1AAAsCT///oAm9n30RcAsi8MsDIAn+bPyyAAsDsvtzjowhXtzBm5mxFyXwuPeA3athWagQ/mwBWDwC5cTQgsJQTHphI8MgbPrRN8aAvFxVkAossAodd5yGlTv1mt3aqc1pNSv1ggtB5HvEfT68iKwC1oVwoeGQMVEQJOQQjDxSKlig/86qX72E2xlBB2tKCFxtK22+3B4ebL5N3i7uGo1uDV08ldt9TQyEmDt5VEsNbo89e44bmM0HpzyXLi8NKS0Ii437Ds8+Ol1pnY0Dr/9db44Yn61jj97rbV7Mq1saOcmY2BfWxtaFNRTDVAOyPRzsJ0cWJRTT6Pi3qtpor988z22WolHwPAxF8zKwWIxc9FOgZjwUjW5a0xpcXe7u5Msd6SytJtudhjt8lMUl3vAAAV/0lEQVR4nNWdjXvTNrfAHYJDnMROmhC76S4rpYVCW9YPYC0fG6Pr+kGhpVDChb0wNnjh8u6y7dJt/PtXlvwhS0e2bEt+7/Xz8FQkTqKfzzk6OtKRZLQMfLUaFik0goLVaBhBgb0lz73iW3Tdy1ezDKCRda8qwBLPthSg/K8olkqOe60yv2Jk3QsAFpJ2qWdb/JP/P1QU36K/kQneia/QQnQBtioFNAz3cGPj0fWj1dU1fN1YW1tdPbr+aGPj0DV0A1r6VLTlvzDeuHb8x2g0RNdoKrrOoH8j9Kr/74/jaxtu+Bk97ZsuwPHG9cdfI4ipM6fIdeZM+DdR8DGHj69vjF3/08zXKbDByCSUquj40dGaLzWKSwRI3vEpbxw9Gpf/aaFDVAj45Nn6FFLJJFc6IL58zV1/9sT/AXWNTB5ACRW1LPfJdaSZUxyXBCApjIZfH790xYCin06pZoFHI2z2nhyvD0cQlzQgluVw/fhQAFikP6IM0H26hvFKAuJ3RsMbT11LhQ2SW1So6OHRaCQyvdyAviBHU0eHuQEF1VQA+HJ1OCVWuwKAfmE0XNuoCjDjV57e8PlUA/qCRMoaNoglqlkO0DKerg+n0hqO4oBYWdeflgU0yqhoy9pYH6ZWuhygXxiub5S0pByPhr3XenJjmF7p8oDoGq69zO63KgFkHqMxfjycqgDQt8fH48LVtIp/8tlolFFpRYB+v3X4rKiiNYrK/uX6KKvS6gBPnZr4+j+ftzIHCATerIgE3ePhqaxKKwW8OWl2XrgFJFgQcGN9KrPSCgEnvvwP22y37R8/5Ktm1GfLLfvjYXalVQLOmz6gadqDF0V6lLkBD9dHVQIiATomBkTX4N5YGOeKQysBoEj210ZTlQLenLQjQLPTMf8hV83igEdDqGq6ALEFUoDtjq+pSgAFsh/7Gloh4E2bAcSa6lo5VLSVKUH6ky+/nKoQ8By2QBYQIU4+N1KrmUTKo6JPhzKVVgaILZAHtJ3NO69kVRTfIi3BZ1UCniMWyAM605drtdpPkioKAwo+eVQpoO8DAUDbmanh67VhSQIasiq6OqoOcOLLbwkfC+hMX6gF18/Zcx4Byf9FwPk2CGh3Z+7UagyiRHAso6LujeoAkQ8kFscCOu1btdppgnca/f2lIaGisoDrFQLebIOASICnKUC/gBBzAwpUdK0yQF+AbQjQaV+I+LAEaxjRyh6/kQGszgYn5idBQLu7cDsGC/8iW8yUIH4ny01UBuj3QkFAIkAO8HSAmDVIkSXBo8oAUSemDQAiC7xNcyUKr8sDVtWTCQJ5HtDpXOW4qMJPmTF8hopW1ReNAnkWEFsgpKJhgfRRUzpn6YAvqwFMBPI0oN2+WksCcq1N7X46oJGqouMvqwFMBPIUoLPwa9imCCSICrfhAEkur229iniQCeRjQJMIME1FceFNGqCVpqKoGa0CcN4GAU176Y4UoN+gpiRkMS8nAK8N9QOygXxUCCww1Qa51kagiyIVPRxBVVMMyATyYQF1Yq5kCI4iDlubnIDYCPUCcoF8WCA+UE5F8S1v4EaGBUyoqHGsfeD33M0OCGh3l27LA5LC+8xZbn5uQvfQPQrk2baFFJzObC0dByq8FZIIXnbXdQPePA8CIgEu5gCMhPyGzWng0r6SKmoc651d8uPADgToOKEFSttgcL2HRSUCfDnUCzjfBgGRAD8ygbwsadCewrPcwMvrp7IqXQIQCdBsQ4COPZsM/+R1tYa7NtC4FCzYZzqnsHEgDwDa3blFyNtJOETy97+gzllyjjQsjDUC+mEECOiYsym1TwcMCrvwsA2QJ/NYX5aFH0aAgN25j6zaZRXYF2r/ZEkEmYmtl0NdgDiMgABtZ1ZOcGlCDhobbpabE6y1pisRCFkgDIgtMGfjCd37C+QYeMBHmlK5SCAPAJrmxSzxyIryrXgSmHp5XROgL0AI0Jn7nal0Jpfw3jf8uBQP+FRLtmEQRvCAph0KsJQN8uNStMdPCnZdByARIOJiAe25Renap9tgLRBiUoJAXpsvQtWAYSDPSdDuXJSvvVxz+ooBtLjG9Yb6jN9zRIA8oDP3DVf7TBXNsNd3SUA+r21jqBrw3JkgkGcBnW4swFKCSxa45pRpe9ZUJ6VPxDPyCUC7e4mLA5W0Nu+MhATZvLbDoVrAOJBnJOg4d0M+JW6CKty3YH9B/nekdt3ExPx5GLB7KbRAVW4iesefjhIDuiOVgEiAYZybBEwKUImboJsqVwxoPB2pBIwD+SQgFmAB8cje+4pGSua1BX1uJYC+BbYhQNsXoEQsVMgGceGdMK/NejJUBzg/CQLaXT9rS5F/FxXuJ+cxYlzrWNXyOiaQpwCdzYK1z/Mw3hswYMNdVwU4TwXytAS7ly6Xrb2MKMOxUy6v7clQCWAykKcA7e5djYITTtRQ8jwuvcSVD+QpQKd9WYHgJByiP+pmUPMYMe7XCgC5QD4sdLAFlmtBJAGvLHVhwCdDBYDJQD4mtadviSqdyZXr3lrtatsZPAfz2p6NygKeI3mhPGDH3rzD1FWt4GLA2wtd2xx8B+a1rZdYR08ASRzIA9o4cxmutFIbrNUutP1Y277XAuZIxyUBkQCTgXyUem7OqKi9DODtmW4Qa7shIJX29WhUDpAN5OPU81vCGim2wQvTTvDT5gceEAVOJQDPnfqWCeTD1PNuKEDdXbVabcaO6oBX1jB5bS1hr1sCMMrMZt1ELEDtXbVbYXI4Tki9FwGGs9ytsajXnQ0IBPJR6nnUBKiyQcG9d2bs5E+PmbSvRmtjWBhw/jznHYLU82jtgO6u2q3pJKA5+JB0iKhNvT4qBkjNyCcB7e5CvHZAs5uYcdg62N+12Ly2VfkdgRKA8x0YEEw91+PxL7dtvo/xLyK7eJbbAjulWYBgIE9Sz2dul2z6Ze89vdkFYu3OjwFgI2xyxlCnNBMQCuRx6rl5QbfgwlsuT3fBUHTgJgGNp0CnNAMwEcjTboJYoILaS9y72YVjbdTUJAGNa6PcgGAg76eet1NTz1V6fCRAMBRFgOefMHltR1n7qjGAE34vFAI0uzhzOU0Rxe/ktMG7Dhxrm/bgv5e3jMQst/FHTkA4kO+gfsVV3YILH9M3l7oCwMHZ73u9z+GERYA5ygPIBPL0SAXJXNZug+i624VjbQT41Uqv3v9k0IANd5QHUBDIU6nn4tqLpZJDi7EA2QY8AByc/77Xr9ebnkt7/NbhUBqQnZGPC06QuazbTfgCtB0YsDP4arlXR4BNb0x7fGNjKA0oCuTNOPVcXGk1Kvr7pS5ch7Y5iQWIAOvejkFPAj8aygFyM/JRP9BeuK1CPDKAFx24DmYHWyABrHvbiVnuRyM5QGEg374qqqtqN/H7XBeug2kSCySAde+HxCz3dXDlAQM4cUYYyPuJr5nCUOImLnYcsA7IBxILDADr/T2DnuU+glYesIBcIB+uIbejzGXdbmJxzobrgDox33/RpwDr/d8seo50FUjrTgKmBPJLV3IBlhDlrAnXAXdiiABDwHr/M+0QSXSYCigM5O1o7YA2/x4UFpfsNgw4CJpQCrDp0YSWEQxDiQChGfkgkJ8LLVC7Dc7aJgxonw0tkAJsevtkACrwilxKaRIwXmLNBPIkc7l87bPvXZzrgqEoFuAXHgfY7GPCaJb7xpQY0N+lgt1hJAjk/cUfpZp+6XtnTWCkAmuRb4FNHrCOCeO8Np9QBDh/HgZ0nFndggsLV5a63DYupIAE2PcgwHr9IDHLnczXowAnTqE4EPry5NoBvV21WdPpwFrkd2KaMCAipGe5bwiWw+IwAvpyB2cua5uopt9BAoQHE4gPFAEiQnqWew1ca0j2iYEAuzhzWcrAJG5JRb/ahgcTOvZZ3wcKAfsHBj0kvAYCzk/CgGZ3VrfgwqdzZwmPVAAPeWD7PlAIWA+8RUTIe/wJMh8IfLlDMpcVtCAZDwMJ0AYHEzpBIJ8C2EwQWtYq5/GjzGz2y+O1A5ptEFngAjxS0UGB/EO/F5oCGPZpQo+/ynj8YEYeALSDzGVtgosByYw1oKIoDvzUq6cDNkm/NPL4R6Mk4Dy8V1q0dkC/m6jdWQgCeV6L4kBeDFjvbxm0Q7w+ogDDGXl+Mzhq7UCpFkRCRS90hIF8EEakA/rxIe3xH1Gb0JxDnRgQ0DHvZtZVUVctTjlgAe02HciLAf0Yn/b4G1F+98QpwV5pdpy5rL2rFqccsFrEBPJiwLq3bdEe/+UojgMFm8HFmcva3cSMY8OAcRyYCVj3diza4x+OojjQBAHzpZ6XchO3pu0kVxzIf8UG8mLAurdLO/wWGfOOA3l2tztg7YCmrtppJuUgLiABen1pwHDMOwBs+HmJyAI7MCDJXNYquLBweToeqUg+5LMPojhQBrC5TNiivLY/pkR7pQUCVNKCZD6MmS48mEAC+TyAwUBUnNd2PPoW3iuNZC6XavqltfjWtAPHudgCm3kAm/2/CWCU9vU/58G90kySuazbv5PCpkMNJtCkuAnNB4gdfiKv7cMABHTI2gFdNkjf+800PZhAP2QiwHyAeGImkdfmQioarh1Q0IJk3Xt6swsPJmAL7OcGrHsNdr82di8VP5Ania85bLCwvV72JzzB4SAcRuQH7C+7bF7bv7i+aHfzdG7BFRFyjaQcgCo6cEggnxew3v/bZfPaXgySgEHmspYsn0TBt8CuYDiIdGIKANb7f1lsXtuHAQ3YsWfKiEf+3lqQcgABBr3QIoB4fjSI7sM2dUw/RuHaAbX+3b++meuyDXjwkKMZ+QKAzZWTAJDKiroXL5IPN82uYCjmrsPsLB9tKWiHgXwRQO9PlwM0XoT+wr50mauRHjdBkn4gCZphGFEMsImHMBhA40MQYzqbYeJr0aZf9t7aRRseLTEH5x+GgXwhQGKG7KlkY7yqPM5c1j4UszjnsB4q2FKQCuSLAdabY2j3lns2veu59q7axQ43mEAKuBNTDtCfWQMO7fpuQKWe63YTi3MBHzccRAfyBQH9bjd0KtnzszPhdoXau2qzbbMDAiYC+aKA9d6uAe7ecrVW0yu48IWPczbfz8dbCiYC+cKA/WVqMwwK0HifA7CMx5/tmkAgY7KBfGHAen/LojfDiBX2fg2ukVpRLi51wVCUDeSLA9a9EwsCtFqNNxoFF74zazowIBPIlwCsH7gUYGL3lvfaBBcW/BlrANDPzH6QCOTLAHpbNGBi95b7xWsvJ3YkQHDjdS6QLwPYbJ7QgEYC953WrtrHBTxSwbsJktSkCtA7EAMar2q6EpxqJOUAlGA4I69Igt6eGNBwazkqnUeL/ZQDOpBPALKBfDnA+opLIzG7txivC9Re4l4kwA6d9kCPlkwGM/KqAHHgJDyVLHCJirtqtdqvC11wQzpqRl4VIHKGCSR6cxM8ofhOneBiQJJyAJ0NwAfyZQFJWJFyKtlb5R6f7HIAAUKBfFlAf6xbcCpZeIzZO1XplIwAeRUdxKn16gD7B27WqWSvaqJKF3ITd2aYQN5MC+RLA/rDF/CZVtFBdC33TTagvIpGM9Ys4MCOZ+QVAiIRZgE2AiEq8fhIgKzpBVsKgoF8ecB6b9vKAkSFKxmAmSoaFi5Ei+QZGxxMPuzxgbwCQCRC8FSyJCDYnBaxwRkb3jof9UI/AYG8AkA/h4YBDDw+83JKcypvg7fiRfJJQCRAKJBXArjvshIkDpHlDmP9Mq3NTLyGPAGI5wNzVDoPYBg2ZQI2jH8Ka5+poqRwa5oGpEgH9sM+FMgrAQxXyTAHrfGADWNcUHDhLZsOvLO8ffbBp15q7UtJcMWFADmPjwX7U4aKpkowsUieBkQ+8Iu+PkASF8oe2vVrcTex6Qi2zidhhD5AMv4keyoZ1djkcRPBGmsIcOAgC9QIGDQz3GGHFgwIhcLZNlgLUg4AwI4/lJZR+3KAZMYQOPIJBmxYbnLsVEaUxAJBQDPoxGgEXHZhQPGhXW+TGNk2GAjQ5N1EGMhrBCRr0wUni4uOunqfS0X5RfLx2QAmtkCtgL3fBICWGNAw3uSZqKldZFLP40D+AZOZrQGwfyBWUeFZXvkmaoKcER4wWNyiGdDPLREe+isCtHJEivwi+XY0ofupl137koA4L0F8Jq4QEHV2XsupKL9IPgzkzz7kllhrAOxtCRuZDEBsitmA/CL5MJB/ACyxVg/YP0hRUeGpZMFgRyOa2BcCIgGyufXtYEL3oQcssVYPuNJIkaDgVLJ4VuNtFuBsx+QBTZOEETK1LwtYb+6knksNn2lFDfOntzZX5hxuYRIJ5J2HPcESa8WAqJXJOjo9DTAKpGBjnHX4RfIkkH+wLFxirRjwrxSPni1B/M5rUZ9tcQnc7a5DhtIqAtzKPDodOJWMjYl/hlubqza44x4TyGsG/OwCozBZp5KxgJb7MwD4EVwk7wfyeD6wGsDefgwoOpfaYP4HnW9tuL9wgH7KAQh4NhHI/1sBhaeSJQFxwUekGxs84QkBMoF8dYAprU2mBHGBSDG88Iw1AIgC+ewl1lVJEMxrSzljPrRFdP26JNjOzyQz8lU1MpKA/KFdnIriT1pRi3q1De92xwXy1QEKW9EcgH4Bj02dXkiOVMSp52wgr9sPStkgdCpZSjf9J/EieZsL5DUD7hmyKsqeSpYWhxivRIvko9T6agD7zfS+aIspSKkovsV4PjkAAO2gCa0McPkku6tWCBB90r034JdYDx7mWWJdGrB3kB4PSgIKlfsFs701FMjrBOx7WzLVFOW1STwa4x8dekzGDyPYQF4r4Mp2TkAmr01Cua3xvcgYwUBeJ2Dv4ESymilpXxKP5sWAhBV4KK1CQKyhOSVYCNAwnv/Y6ZAmlKuITsDlnYxqsm6CO5Ush+xfDBIz8hUAeqgbI6hmqgT5WW5J5X7+1fIXfEU0Ah7AE6DZozCG4APZj2ZvhRtM0wboNf8STGFnVrM4oGHsfm5W01Xzmp93M6sJ2yAHmEf26IWT/Z7+iL7v7bOJQLmqKfpkpgTJl28faB747XvLO2wqV75qQk9EHhBdOweevvnBvnew7YoEJ6OiyUng/BIkOQ3b+56eNBLCJ9+jzAGYrdyJX3F39j312YbI/pB+FnPXiVtKqWjUH9/dWumrXFbgeStb3LqJgtUsAUj3xw13b39F2fK65sGeK/vT6TYYXUVUlLvl5DfU6pTaKABdfdR6/nYi+OkiTUVxQOBXLPdka7nXL7AjUHBLv99b3jqRHPyTlENWpfPrye7eQdPLMbIY9cz6XnN/b9cI9wJUYoNGcpZbCSCG3N76c8UT7bPNF/pINVf+3NreTdRBAjDTBq3UtK9yln6y/dffnzyksulZzz6ct/z3X9snbsZPF69mIeuVuBdpm9vY2dv6vOz5F0bBytsP/4eu5c9bezsN17Uyv654NYv1ZHK11e7uzvYPe1tbn/f3D/xrf/8zAvthe2fXzfrekjZIjFAvYDxIR7fd5IXQbiUAy8hBiZvI8TAK2VUpb6ag0toBSz3bigGlp8TU/XQ1v1K5imbNcmuXSnUSbLT+F2Bb9o0XxDz8AAAAAElFTkSuQmCC',
    },
    {
      name: 'Brand 7',
      image:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ1qjj3UBL-gMF6RUVWZFZwc6f3GaObJGZSMg&usqp=CAU',
    },
    {
      name: 'Brand 8',
      image:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0DHkhLoAn76-SiYwKqsf36wey5wZ9Zi48jw&usqp=CAU',
    },
    {
      name: 'Brand 9',
      image:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRp8v4sdazKWZVu31fhKbMpTiJJxYQiJ5i0eQ&usqp=CAU',
    },
    {
      name: 'Brand 10',
      image:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQEI_dT8dkrRqEbCHKq7mA2WS7XJ7CSEDTUQA&usqp=CAU',
    },
  ];

  bubblecommonfunction(event: any, checkboxchecked: any, chartproperties: any) {
    switch (checkboxchecked) {
      case 'Dark Theme': {
        event.target.classList.toggle('checked')
          ? (chartproperties['darkTheme'] = true)
          : (chartproperties['darkTheme'] = false);
        break;
      }
      case 'Show Gradient#': {
        event.target.classList.toggle('checked')
          ? (chartproperties['showGradient'] = true)
          : (chartproperties['showGradient'] = false);
        break;
      }
      case 'Legend Position : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['legendPosition'] = value;
        break;
      }

      case 'Data Label : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['showDataLabel'] = value === 'disable' ? false : true;
        break;
      }

      case 'Image :': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['image'] = value === 'disable' ? false : true;
        break;
      }
      case 'Legend : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['showLegend'] = value === 'disable' ? false : true;
        break;
      }
      case '2D/3D Chart# :': {
        chartproperties['is3DChart'] =
          event.target.value == '2D' ? false : true;
        break;
      }
      case 'Data Label position# : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['datalabelOrientation'] = value;
        break;
      }

      case 'ToolTip Style# : ': {
        chartproperties['toolTipStyle'] = event.target.value;
        break;
      }
      case 'Marker/Bubble Size :': {
        chartproperties['markersize'] = event.target.value;
        break;
      }
      case 'Data Label Property : ': {
        chartproperties['datalabelStyle'] = event.target.value;
        break;
      }
      case 'GridLines': {
        event.target.classList.toggle('checked')
          ? (chartproperties['gridlines'] = true)
          : (chartproperties['gridlines'] = false);
        break;
      }
      case 'Data Label Format : ': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['datalabelFormat'] = value;
        break;
      }
      case 'Quadrant Dash Style :': {
        chartproperties['dashStyle'] = event.target.value;
        break;
      }
      case 'Quadrant Text :': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['showQuadrantText'] =
          value === 'enable' ? 'enable' : 'disable';
        break;
      }
      case 'Data Label Color : ': {
        chartproperties['dataLabelColor'] = event.target.value;
        break;
      }
      case 'Chart Title Position :': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        chartproperties['chartTitlePosition'] = value;
        break;
      }
      case 'Data Label Size# : ': {
        chartproperties['datalabelSize'] = event.target.value;
        break;
      }
    }
  }

  bubblecustomizationService1() {
    let custom: any = [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "",
        id: 'Dark Theme'
      },

      {
        customization: 'GridLines',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "",
        id: 'GridLines'
      },
      {
        customization: 'Chart Title Position :',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "",
        id: 'Chart Title Position :',
        options: [
          {
            value: 'left',
            label: 'Left',
            selected: false,
            imgClassName: 'titleLeft',
            selectedImgClassName: 'titleLeftSelected',
          },

          {
            value: 'center',
            label: 'Center',
            selected: true,
            imgClassName: 'titleCenter',
            selectedImgClassName: 'titleCenterSelected',
          },
          {
            value: 'right',
            label: 'Right',
            selected: false,
            imgClassName: 'titleRight',
            selectedImgClassName: 'titleRightSelected',
          },
        ],
      },
      {
        customization: 'Image :',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "",
        id: 'Image :',
        options: [
          {
            value: 'disable',
            label: 'Disable',
            selected: true,
            imgClassName: 'legendDisable',
            selectedImgClassName: 'legendDisableSelected',
          },
          {
            value: 'enable',
            label: 'Enable',
            selected: false,
            imgClassName: 'legendEnable',
            selectedImgClassName: 'legendEnableSelected',
          },
        ],
      },
      {
        customization: '2D/3D Chart# :',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "",
        id: '2D/3D Chart# :',
        options: [
          { value: '2D', label: '2D' },
          { value: '3D', label: '3D' },
        ],
      },

      {
        customization: 'Marker/Bubble Size :',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "",
        id: 'Marker/Bubble Size :',
        options: [
          { value: 'default', label: 'Default' },
          { value: '10', label: '10' },
          { value: '25', label: '25' },
          { value: '50', label: '50' },
          { value: '75', label: '75' },
          { value: '100', label: '100' },
        ],
      },
      {
        customization: 'ToolTip Style# : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "",
        id: 'ToolTip Style# : ',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ],
      },
      {
        customization: 'Legend : ',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "Legend",
        id: 'Legend : ',
        options: [
          {
            value: 'disable',
            label: 'Disable',
            selected: false,
            imgClassName: 'legendDisable',
            selectedImgClassName: 'legendDisableSelected',
          },
          {
            value: 'enable',
            label: 'Enable',
            selected: true,
            imgClassName: 'legendEnable',
            selectedImgClassName: 'legendEnableSelected',
          },
        ],
      },
      {
        customization: 'Position : ',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "LegendGrouping",
        id: 'Legend Position : ',
        options: [
          {
            value: 'left',
            label: 'Left',
            selected: false,
            imgClassName: 'legendLeft',
            selectedImgClassName: 'legendLeftSelected',
          },
          {
            value: 'bottom',
            label: 'Bottom',
            selected: false,
            imgClassName: 'legendBottom',
            selectedImgClassName: 'legendBottomSelected',
          },
          {
            value: 'right',
            label: 'Right',
            selected: true,
            imgClassName: 'legendRight',
            selectedImgClassName: 'legendRightSelected',
          }, // Add this option for 'Right'
        ],
      },
      {
        customization: 'Data Label : ',
        func: 'oncheckboxchecked',
        inputType: 'toggle',
        className: "DataLabel",
        id: 'Data Label : ',
        options: [
          { value: 'enable', label: 'On', selected: true },
          { value: 'disable', label: 'Off', selected: false },
        ],
      },

      {
        customization: 'Color : ',
        func: 'oncheckboxchecked',
        inputType: 'color',
        value: '#000000',
        className: "DataLabelGrouping",
        id: 'Data Label Color : ',
      },

      {
        customization: 'Format : ',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "DataLabelGrouping",
        id: 'Data Label Format : ',
        options: [
          {
            value: 'number',
            label: 'Number',
            selected: true,
            imgClassName: 'formatNumber',
            selectedImgClassName: 'formatNumberSelected',
          },
          {
            value: 'percentage',
            label: 'Percentage',
            selected: false,
            imgClassName: 'formatPercentage',
            selectedImgClassName: 'formatPercentageSelected',
          },
        ],
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "DataLabelGrouping",
        id: 'Data Label Property : ',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          {
            value: 'changeversus+significance',
            label: 'Change Versus + Significance',
          },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },

          { value: 'ls', label: 'Low Sample' },
        ],
      },
      {
        customization: 'Size# : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "DataLabelGrouping",
        id: 'Data Label Size# : ',
        options: [
          { value: 'Default', label: 'Default' },
          { value: '0.6em', label: '0.6em' },
          { value: '0.7em', label: '0.7em' },
          { value: '0.8em', label: '0.8em' },
          { value: '0.9em', label: '0.9em' },
          { value: '1em', label: '1em' },
        ],
      },

      {
        customization: 'Position# : ',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: 'DataLabelGrouping',
        id: 'Data Label position# : ',
        options: [
          {
            value: 0,
            label: 'default',
            selected: true,
            imgClassName: 'axisHorizontal',
            selectedImgClassName: 'axisHorizontalSelected',
          },
          {
            value: -90,
            label: 'Vertical Right',
            selected: false,
            imgClassName: 'axisVerticalRight',
            selectedImgClassName: 'axisVerticalRightSelected',
          },
          {
            value: 90,
            label: 'Vertical Left',
            selected: false,
            imgClassName: 'axisVerticalLeft',
            selectedImgClassName: 'axisVerticalLeftSelected',
          },
          {
            value: 45,
            label: 'Diagonal Right',
            selected: false,
            imgClassName: 'axisdiagonalRight',
            selectedImgClassName: 'axisdiagonalRightSelected',
          },
          {
            value: -45,
            label: 'Diagonal Left',
            selected: false,
            imgClassName: 'axisdiagonalLeft',
            selectedImgClassName: 'axisdiagonalLeftSelected',
          },
        ],
      },
    ];

    return custom;
  }

  bubblecustomizationService2() {
    let custom: any = [
      {
        customization: 'Dark Theme',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "",
        id: 'Dark Theme'
      },

      {
        customization: 'GridLines',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "",
        id: 'GridLines'
      },

      {
        customization: 'Show Gradient#',
        func: 'oncheckboxchecked',
        inputType: 'checkbox',
        className: "",
        id: 'Show Gradient#'
      },

      {
        customization: 'Chart Title Position :',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "",
        id: 'Chart Title Position :',
        options: [
          {
            value: 'left',
            label: 'Left',
            selected: false,
            imgClassName: 'titleLeft',
            selectedImgClassName: 'titleLeftSelected',
          },

          {
            value: 'center',
            label: 'Center',
            selected: true,
            imgClassName: 'titleCenter',
            selectedImgClassName: 'titleCenterSelected',
          },
          {
            value: 'right',
            label: 'Right',
            selected: false,
            imgClassName: 'titleRight',
            selectedImgClassName: 'titleRightSelected',
          },
        ],
      },
      {
        customization: 'Image :',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "",
        id: 'Image :',
        options: [
          {
            value: 'disable',
            label: 'Disable',
            selected: true,
            imgClassName: 'legendDisable',
            selectedImgClassName: 'legendDisableSelected',
          },
          {
            value: 'enable',
            label: 'Enable',
            selected: false,
            imgClassName: 'legendEnable',
            selectedImgClassName: 'legendEnableSelected',
          },
        ],
      },
      {
        customization: '2D/3D Chart# :',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "",
        id: '2D/3D Chart# :',
        options: [
          { value: '2D', label: '2D' },
          { value: '3D', label: '3D' },
        ],
      },

      {
        customization: 'Marker/Bubble Size :',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "",
        id: 'Marker/Bubble Size :',
        options: [
          { value: 'default', label: 'Default' },
          { value: '10', label: '10' },
          { value: '25', label: '25' },
          { value: '50', label: '50' },
          { value: '75', label: '75' },
          { value: '100', label: '100' },
        ],
      },

      {
        customization: 'ToolTip Style# : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "",
        id: 'ToolTip Style# : ',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ],
      },

      {
        customization: 'Quadrant Dash Style :',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "",
        id: 'Quadrant Dash Style :',
        options: [
          { value: 'dash', label: 'Dash' },
          { value: 'shortdash', label: 'ShortDash' },
          { value: 'dot', label: 'Dot' },
          { value: 'solid', label: 'Solid' },
          { value: 'shortDashDot', label: 'ShortDashDot' },
          { value: 'shortDashDotDot', label: 'ShortDashDotDot' },
          { value: 'longDash', label: 'LongDash' },
          { value: 'longDashDot', label: 'LongDashDot' },
        ],
      },

      {
        customization: 'Quadrant Text :',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "",
        id: 'Quadrant Text :',
        options: [
          {
            value: 'disable',
            label: 'Disable',
            selected: true,
            imgClassName: 'legendDisable',
            selectedImgClassName: 'legendDisableSelected',
          },
          {
            value: 'enable',
            label: 'Enable',
            selected: false,
            imgClassName: 'legendEnable',
            selectedImgClassName: 'legendEnableSelected',
          },
        ],
      },
      {
        customization: 'Legend : ',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "Legend",
        id: 'Legend : ',
        options: [
          {
            value: 'disable',
            label: 'Disable',
            selected: false,
            imgClassName: 'legendDisable',
            selectedImgClassName: 'legendDisableSelected',
          },
          {
            value: 'enable',
            label: 'Enable',
            selected: true,
            imgClassName: 'legendEnable',
            selectedImgClassName: 'legendEnableSelected',
          },
        ],
      },
      {
        customization: 'Position : ',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "LegendGrouping",
        id: 'Legend Position : ',
        options: [
          {
            value: 'left',
            label: 'Left',
            selected: false,
            imgClassName: 'legendLeft',
            selectedImgClassName: 'legendLeftSelected',
          },
          {
            value: 'bottom',
            label: 'Bottom',
            selected: false,
            imgClassName: 'legendBottom',
            selectedImgClassName: 'legendBottomSelected',
          },
          {
            value: 'right',
            label: 'Right',
            selected: true,
            imgClassName: 'legendRight',
            selectedImgClassName: 'legendRightSelected',
          }, // Add this option for 'Right'
        ],
      },
      {
        customization: 'Data Label : ',
        func: 'oncheckboxchecked',
        inputType: 'toggle',
        className: "DataLabel",
        id: 'Data Label : ',
        options: [
          { value: 'enable', label: 'On', selected: true },
          { value: 'disable', label: 'Off', selected: false },
        ],
      },
      {
        customization: 'Color : ',
        func: 'oncheckboxchecked',
        inputType: 'color',
        value: '#000000',
        className: "DataLabelGrouping",
        id: 'Data Label Color : ',
      },

      {
        customization: 'Format : ',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: "DataLabelGrouping",
        id: 'Data Label Format : ',
        options: [
          {
            value: 'number',
            label: 'Number',
            selected: true,
            imgClassName: 'formatNumber',
            selectedImgClassName: 'formatNumberSelected',
          },
          {
            value: 'percentage',
            label: 'Percentage',
            selected: false,
            imgClassName: 'formatPercentage',
            selectedImgClassName: 'formatPercentageSelected',
          },
        ],
      },
      {
        customization: 'Property : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "DataLabelGrouping",
        id: 'Data Label Property : ',
        options: [
          { value: 'default', label: 'Default' },
          { value: 'changeversus', label: 'Change Versus' },
          {
            value: 'changeversus+significance',
            label: 'Change Versus + Significance',
          },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },

          { value: 'ls', label: 'Low Sample' },
        ],
      },

      {
        customization: 'Size# : ',
        func: 'oncheckboxchecked',
        inputType: 'dropdown',
        className: "DataLabelGrouping",
        id: 'Data Label Size# : ',
        options: [
          { value: 'default', label: 'Default' },
          { value: '0.6em', label: '0.6em' },
          { value: '0.7em', label: '0.7em' },
          { value: '0.8em', label: '0.8em' },
          { value: '0.9em', label: '0.9em' },
          { value: '1em', label: '1em' },
        ],
      },

      {
        customization: 'Position# : ',
        func: 'oncheckboxchecked',
        inputType: 'images',
        className: 'DataLabelGrouping',
        id: 'Data Label position# : ',
        options: [
          {
            value: 0,
            label: 'default',
            selected: true,
            imgClassName: 'axisHorizontal',
            selectedImgClassName: 'axisHorizontalSelected',
          },
          {
            value: 90,
            label: 'Vertical Left',
            selected: false,
            imgClassName: 'axisVerticalLeft',
            selectedImgClassName: 'axisVerticalLeftSelected',
          },
          {
            value: -90,
            label: 'Vertical Right',
            selected: false,
            imgClassName: 'axisVerticalRight',
            selectedImgClassName: 'axisVerticalRightSelected',
          },
          {
            value: 45,
            label: 'Diagonal Right',
            selected: false,
            imgClassName: 'axisdiagonalRight',
            selectedImgClassName: 'axisdiagonalRightSelected',
          },
          {
            value: -45,
            label: 'Diagonal Left',
            selected: false,
            imgClassName: 'axisdiagonalLeft',
            selectedImgClassName: 'axisdiagonalLeftSelected',
          },
        ],
      },
    ];

    return custom;
  }
}
